import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthLogout } from "./index"

export const propertyMappingApi = createApi({
    reducerPath: "propertyMappingApi",
    baseQuery: baseQueryWithAuthLogout,
    tagTypes: ["PropertyMapping"],
    endpoints: (builder) => ({
        getPropertyMappingData: builder.query({
            query: ({ page = 1, limit = 25, search = "" }) => `/property-mappings?page=${page}&limit=${limit}&search=${search}`,
            providesTags: ["PropertyMapping"],
        }),

        savePropertyMapping: builder.mutation({
            query: (payload) => ({
                url: `/property-mappings`,
                method: "POST",
                body: payload,
            }),
            invalidatesTags: ["PropertyMapping"],
        }),
        updatePropertyMapping: builder.mutation({
            query: ({ id, data }) => ({
                url: `/property-mappings/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["PropertyMapping"],
        }),

        deletePropertyMapping: builder.mutation({
            query: (id) => ({
                url: `/property-mappings/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["PropertyMapping"],
        }),
    }),
});

export const {
    useGetPropertyMappingDataQuery,
    useSavePropertyMappingMutation,
    useUpdatePropertyMappingMutation,
    useDeletePropertyMappingMutation
} = propertyMappingApi;
